module.exports = __webpack_public_path__ + "static/media/Logo_DT_Colour.8021dd44.png";